// extracted by mini-css-extract-plugin
export default {"innerWrapper":"tt-z","tooltipWrapper":"ut-z","icon":"vt-z","tooltip":"wt-z","content":"xt-z"};